import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";

import { cn } from "@utils/ui";

type SelectionActionBarProps = {
  count: number;
  onClear: () => void;
  label?: ReactNode;
  actions?: ReactNode;
  disabled?: boolean;
  className?: string;
};

export const SelectionActionBar = ({
  count,
  onClear,
  label,
  actions,
  disabled,
  className,
}: SelectionActionBarProps) => {
  if (count <= 0) return null;

  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-md border border-primary/30 bg-primary/5 px-3 py-1.5",
        className
      )}
      role="region"
      aria-label="Selection actions"
    >
      <span className="text-xs font-medium text-primary">
        {label ?? `${count} selected`}
      </span>
      <div className="ml-auto flex items-center gap-1.5">
        {actions}
        <Button variant="ghost" size="compact" onClick={onClear} disabled={disabled}>
          Clear
        </Button>
      </div>
    </div>
  );
};
